<template>
  <div>
    <div class="content-wrapper" @clickCont="clickCont">
      <div :class="[full ? 'content-wrapper-wrapper' : '']" id="post">
        <span>{{tip}}</span>
        <div
          v-for="(keyword, idx) in contentList"
          class="post-content-wrapper"
          :key="keyword.id"
        >
          <span
            class="content-plain"
            v-if="keyword.type === 'text'"
          >{{keyword.text}}</span>
          <img
            class="content-emoji"
            v-if="keyword.type === 'emoji'"
            :src="keyword.src"
          />
          <span
            class="content-plain"
            v-if="keyword.type === 'label'&&!(keyword.keywordType===100)"
          >{{keyword.text}}</span>
          <span
            class="content-blue"
            v-if="keyword.type === 'label'&&keyword.keywordType===100"
            @click.stop="textToImgDetail(0, contentList, idx)"
          >{{keyword.text}}</span>
        </div>
      </div>
    </div>
    <div class="text-wrapper" v-if="isShowText">
      <span>全文</span>
    </div>
  </div>
</template>

<script>
import Util from '@/base/Util';

export default {
  props: {
    tip: {
      type: String,
    },
    content: {
      type: String,
      default: '',
    },
    keyWords: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      full: true,
      fullContent: '',
      contentList: [],
      postHeightFull: 0,
      postHeight: 0,
      isShowText: false,
    };
  },
  async mounted() {
    this.fullContent = this.content;
    this.formatContentFull();
    this.$nextTick(async () => {
      await this.initPost('postHeightFull');
      this.full = false;
      this.$nextTick(async () => {
        await this.initPost('postHeight');
        if (this.postHeightFull > this.postHeight) {
          this.isShowText = true;
        }
      });
    });
  },
  methods: {
    clickCont() {
    },
    initPost() {
      // const SelectorQuery = uni.createSelectorQuery().in(this);

      // return new Promise((reslove) => {
      //   SelectorQuery.select('#post').boundingClientRect((data) => {
      //     this[str] = data.height;
      //     reslove();
      //   }).exec();
      // });
    },
    formatContentFull() {
      const content = [];
      if (this.fullContent) {
        const strList = this.fullContent.split(
          /(\[[\u4e00-\u9fa5]+\]|<!--adr\d*-->)/g,
        );
        strList.forEach((str) => {
          if (str.match(/\[[\u4e00-\u9fa5]+\]/g)) {
            const srcMatched = Util.handleEmoji(str);
            if (srcMatched) {
              const emoji = {
                type: 'emoji',
                src: srcMatched,
              };
              content.push(emoji);
            } else {
              const text = {
                type: 'text',
                text: str,
              };
              content.push(text);
            }
            // 表情处理
          } else if (str.match(/<!--adr\d*-->/g)) {
            // 占位符类型
            const keywordMatched = Util.keywordType(
              this.keyWords,
              'Label',
              str,
            );
            if (keywordMatched.text === 'no match') {
              const text = {
                type: 'text',
                text: str,
              };
              content.push(text);
            } else {
              const label = {
                type: 'label',
                keywordType: keywordMatched.type,
                text: keywordMatched.text,
                srcList: keywordMatched.srcList,
              };
              content.push(label);
            }
          } else {
            // 普通文字
            const text = {
              type: 'text',
              text: str,
            };
            content.push(text);
          }
        }, this);
        this.contentList = content;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@font-size: 32px;
@line-height: 1.7;
@lines-to-show: 3;

.content-wrapper {
  display: block; /* Fallback for non-webkit */
  display: -webkit-box;
  margin-top: 10px;
  font-size: @font-size;
  line-height: @line-height;
  -webkit-line-clamp: @lines-to-show;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.post-content-wrapper {
  display: inline;
  .content-emoji {
    width: 38px;
    height: 38px;
    vertical-align: middle;
    margin-left: 7px;
  }

  .content-blue {
    color: #4C618F;
    word-break: break-all;
  }

  .content-plain {
    word-break: break-all;
  }
}

.content-wrapper-wrapper {
  height: 100%;
}

.text-wrapper {
  font-size: 32px;
  line-height: 46px;
  color: #83A6CF;
  text-align: right;
}

</style>
